import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { spacing } = theme.busbud;

  return {
    legend: { margin: spacing(0, 1) }
  };
});
